export function getView(acknowledge_array, patient_id) {
  // Required for transitions between top tabs (From one patient to another, for example)
  return (
    !!patient_id &&
    Array.isArray(acknowledge_array) &&
    !acknowledge_array.includes(patient_id)
  )
}
